module.exports = __webpack_public_path__ + "static/media/027.51627a43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/027.jpg
// module id = 374
// module chunks = 0